// Mesajlar sekmesi aramasi: yuklu sohbet listesinde istemci tarafinda suzer (ek istek yok).
// Eslesme alanlari: AI basligi, AI ozeti, temsilci adlari, listede gelen son mesaj metinleri.
const norm = (s) => String(s || "").toLocaleLowerCase("tr").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ı/g, "i");

const haystack = (c, title) => {
    const ai = (c && c.ai) || {};
    const users = ((c && c.users) || []).map((u) => u && u.name).filter(Boolean);
    const texts = ((c && c.messages) || []).map((m) => m && m.description).filter((t) => typeof t === "string");
    return norm([title, ai.title, ai.summary, ...users, ...texts].join(" \n "));
};

/**
 * @param {Array} conversations
 * @param {string} query - 2 karakterden kisaysa liste aynen doner
 * @param {(c: object) => string} titleOf - ekrandaki baslik (eslesmeye dahil)
 */
export const filterConversations = (conversations, query, titleOf = () => "") => {
    const q = norm(query).trim();
    if (q.length < 2) return conversations || [];
    const words = q.split(/\s+/).filter(Boolean);
    return (conversations || []).filter((c) => {
        const h = haystack(c, titleOf(c));
        return words.every((w) => h.includes(w));
    });
};



// WEBPACK FOOTER //
// ./src/utils/shell/conversationSearch.js